import React, { useState, useEffect } from 'react';
import '../../stylesheets/FreeTrial.css';
import InsertMailModal from './InsertMailModal';
import VerifyPasswordModal from './VerifyPasswordModal';
import TrialActivationModal from './TrialActivationModal';
import ErrorMessage from '../../app/ErrorMessage';
import { useSelector, useDispatch } from 'react-redux';
import { checkUdid } from './userSlice';
import { getUdid } from '../../api/mobile';
import { useHistory } from 'react-router-dom';


const FreeTrialPage = () => {
    const [step, setStep] = useState('insert_mail');
    const udidStatus = useSelector((state) => state.user.udid.status);
    const udidError = useSelector((state) => state.user.udid.error);
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(async () => {
        if (udidStatus === 'idle') {
            const udid = await getUdid();
            
            dispatch(checkUdid(udid));
        }
    }, [udidStatus, dispatch]);
    
    const passwordModal = <VerifyPasswordModal onGoBack={() => setStep('insert_mail')} onGoAhead={() => setStep('trial_activation')}/>;
    
    return (<div id="free_trial_page">
    {udidStatus === 'loading' ? <div className="loader"></div> : 
            udidStatus === 'failed' 
    ? udidError == 'trial exists but not yet confirmed' 
    ? passwordModal : <ErrorMessage message={udidError} onGoBack={() => history.push('/')}/> :
            udidStatus == 'succeeded' && step == 'insert_mail' 
    ? <InsertMailModal onGoAhead={() => setStep('insert_password')}/> 
    : step == 'insert_password' ? 
    passwordModal 
    : step == 'trial_activation' ? 
    <TrialActivationModal onGoBack={() => setStep('insert_password')}/> : null}
    </div>);
    };


export default FreeTrialPage;